import Vue from 'vue';
import VueRouter from 'vue-router';

import AuthorizationUtility from '@/utilities/authorization-utility';
import Store from '@/store';
import AccountRoute from './routes/account.route';
import AgreementsRoute from './routes/agreements.route';
import ErrorRoute from './routes/error.route';
import ForwardDocumentRoute from './routes/forward-document.route';
import HomeRoute from './routes/home.route';
import InspectionRoute from './routes/inspection.route';
import InspectionsRoute from './routes/inspections.route';
import InspectorsRoute from './routes/inspectors.route';
import InvoiceRoute from './routes/invoice.route';
import OffersRoute from './routes/offers.route';
import PaymentRoute from './routes/payment.route';
import RateInspectorRoute from './routes/rate-inspector.route';
import ReceiptRoute from './routes/receipt.route';
import ReportRoute from './routes/report.route';
import UsedCardboardBoxesRoute from './routes/used-cardboard-boxes.route';
import WelcomeRoute from './routes/welcome.route';
import SpareFootRoute from './routes/spare-foot.route';
import AllConnectRoute from './routes/all-connect.route';
import UnPaktRoute from './routes/unpakt.route';
import BellhopRoute from './routes/bellhop.route';

const router = new VueRouter({
  mode: 'history',
  routes: [
    AccountRoute,
    AgreementsRoute,
    ErrorRoute,
    ForwardDocumentRoute,
    HomeRoute,
    InspectionRoute,
    InspectionsRoute,
    InspectorsRoute,
    InvoiceRoute,
    OffersRoute,
    PaymentRoute,
    RateInspectorRoute,
    ReceiptRoute,
    ReportRoute,
    UsedCardboardBoxesRoute,
    WelcomeRoute,
    SpareFootRoute,
    AllConnectRoute,
    UnPaktRoute,
    BellhopRoute,
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  await AuthorizationUtility.validateUserType(Store, next);
});

Vue.use(VueRouter);
export default router;
